export * from './freedom'
export * from './money'
export * from './hours'
export * from './speed'
export * from './easy'
export * from './transparency'
export * from './easyNZ'
export * from './flexibleNZ'

export type ImageProps = {
  width: number
  height: number
}
